import { useQuery } from 'react-query';
import api from 'api';

const QUERY_KEY = 'TAX_DECLARATION_SETTINGS_80G';

/**
 * Hook to check if 80G section is disabled at the organization level.
 * This is used to filter out Section 80G from tax exemption sections
 * when creating or editing salary components.
 */
const useIs80GDisabled = () => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: api.taxDeclarations.getSettings,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return {
    is80GDisabled: data?.disable80g ?? false,
    isLoading,
  };
};

export default useIs80GDisabled;

